<template>
    <footer class="vz-footer">
        <div class="legal">
            <router-link to="/privacy">
                {{ $t('privacy-policy.title') }}
            </router-link>
            <span>•</span>
            <router-link to="/disclaimer">
                {{ $t('disclaimer.title') }}
            </router-link>
            <span>•</span>
            <router-link to="/contact">
                {{ $t('contact.title') }}
            </router-link>
        </div>
        <div class="version">
            <vz-version :copyright="$t('general.company')" :prefix="$t('general.version-short')" />
        </div>
    </footer>
</template>

<style scoped lang="scss">
    .vz-footer {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        height: min-content;
        padding: 1rem;

        @include breakpoint(medium) {
            padding-inline: 2rem;
        }

        .legal,
        .version {
            align-items: center;
            display: flex;
            flex-flow: row wrap;
            gap: 0.5rem;
            width: 100%;
        }
    }
</style>
